import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { circularMod } from "@faire/retailer-visitor-shared/lib/math";
import { EyebrowText, FadingImage, horizontalPadding, Section } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { observer } from "mobx-react";
import React, { useEffect, useCallback, useState, useRef } from "react";
import styled from "styled-components";
var HeroSectionBase = function(props) {
    var _useState = _sliced_to_array(useState(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var isMounted = useRef(false);
    var children = props.children, eyebrowText = props.eyebrowText, eyebrowColor = props.eyebrowColor, heroImages = props.heroImages, backgroundColor = props.backgroundColor;
    var resumeScrollHandler = useCallback(function() {
        setTimeoutIfPossible(function() {
            setCurrentIndex(circularMod(currentIndex + 1, props.heroImages.length));
            resumeScrollHandler();
        }, 2000);
    }, [
        currentIndex,
        props.heroImages.length
    ]);
    useEffect(function() {
        if (isMounted.current) {
            return;
        }
        isMounted.current = true;
        resumeScrollHandler();
    }, [
        resumeScrollHandler
    ]);
    var isSSR = useIsSSR();
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    return /*#__PURE__*/ _jsx(Section, {
        $backgroundColor: backgroundColor,
        children: /*#__PURE__*/ _jsxs(ResponsiveContainer, {
            children: [
                /*#__PURE__*/ _jsxs(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(EyebrowText, {
                            color: eyebrowColor,
                            children: eyebrowText
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: isDesktopAndAbove ? "3x" : "2x"
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ _jsx(ImageContainer, {
                    children: heroImages.map(function(imageUrl, index) {
                        return /*#__PURE__*/ _jsx(HeroImage, {
                            src: optimizeImageUrl({
                                url: imageUrl
                            }, isSSR),
                            $isActive: index === currentIndex
                        }, index);
                    })
                })
            ]
        })
    });
};
export var HeroSection = observer(HeroSectionBase);
var ResponsiveContainer = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-7e7f90e7-0"
})([
    "width:100%;max-width:1660px;margin:0 auto;"
]);
var ContentWrapper = styled(Column).attrs({
    justify: "center",
    align: "flex-start"
}).withConfig({
    componentId: "sc-7e7f90e7-1"
})([
    "",
    " ",
    "{padding-top:",
    ";padding-bottom:",
    ";}",
    "{width:50%;padding-right:96px;padding-top:",
    ";padding-bottom:",
    ";}"
], horizontalPadding, responsiveMediaQueries.tabletAndBelow, getSpacing("7x"), getSpacing("7x"), responsiveMediaQueries.desktopAndAbove, getSpacing("10x"), getSpacing("10x"));
var ImageContainer = styled.div.withConfig({
    componentId: "sc-7e7f90e7-2"
})([
    "position:relative;width:100%;overflow:hidden;padding-top:100%;",
    "{flex-shrink:0;width:50%;max-width:733px;padding-top:initial;}",
    "{min-height:696px;}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
var HeroImage = styled(FadingImage).withConfig({
    componentId: "sc-7e7f90e7-3"
})([
    "position:absolute;top:0;left:0;max-width:100%;object-fit:cover;height:100%;margin:auto;"
]);
